import { render, staticRenderFns } from "./MailCodeComponent.vue?vue&type=template&id=2bc6bc88&"
import script from "./MailCodeComponent.vue?vue&type=script&lang=js&"
export * from "./MailCodeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports